webpackJsonp([263791100135453],{

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _config = __webpack_require__(10);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'span',
	            {
	                style: {
	                    fontFamily: "'Alex brush', cursive",
	                    fontSize: '80px',
	                    fontWeight: 'bold',
	                    color: _config2.default.site.textColor,
	                    lineHeight: '1em'
	                } },
	            _config2.default.personalInfo.bride + ' & ' + _config2.default.personalInfo.groom
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'p',
	            { style: {
	                    fontWeight: 'bold',
	                    fontFamily: "'Dancing Script', cursive",
	                    fontSize: '25px',
	                    color: _config2.default.site.textColor
	                } },
	            'Thank you for joining us virtually! Here\u2019s a brief timeline of our journey:'
	        ),
	        _react2.default.createElement('img', { src: _config2.default.img.bridePic, alt: _config2.default.personalInfo.bride }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'October 2017 - Gabriel moves from Amsterdam to Seattle.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.space_needle, alt: 'SpaceNeedle' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'February 2, 2018 - Samara & Gabriel go on their first date in Fremont. They walk to the Troll.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.troll, alt: 'Troll' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'March 2018 - They say \u201CI love you\u201D for the first time'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'April 2018 - They spend their birthday visiting Sedona & the Grand Canyon.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.sedona, alt: 'Sedona' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'June 2018 - Gabriel meets Samara\u2019s parents & grandparents in Spokane.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'October 2018 - They dress up as Ariel & Eric for Halloween....(with Shady)'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.ariel, alt: 'Ariel' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'November 2018 - Westley joins the family (because of Shady) and they move to Fremont, right next to the Troll.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.fremont, alt: 'Fremont' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'December 2018 - First Christmas!.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.christmas, alt: 'Christmas' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'April 2019 - They go wine-tasting in Chelan for their birthday.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.chelan, alt: 'Chelan' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'July 2019 - They spend a week in Northern California--Napa for a cousin\u2019s wedding, exploring San Francisco, relaxing in Monterey, and driving through Big Sur.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.napa, alt: 'Napa' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'September 2019 - They travel to Romania. Samara meet\u2019s Gabriel\u2019s Mom along with other friends and family. They visit special spots from his childhood.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.romania, alt: 'Romania' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'October 2019 - For Halloween, they go as Han & Leia. Westley is Yoda.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.yoda, alt: 'Yoda' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'December 24, 2019 - Gabriel proposes. Samara says \u201CYes!\u201D'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.proposal, alt: 'Proposal' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'February 2020 - Gabriel gets reconstructive knee surgery. Project manager that she is, Samara keeps them on a tight schedule during the first days of recovery.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.surgery, alt: 'Surgery' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'right' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'April 2020 - They start out their birthday rushing Samara to the hospital. She has a blood clot in her lung and is admitted to the hospital. He takes care of her for weeks as she recuperates.'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.hospital, alt: 'Hospital' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	                'p',
	                { className: 'biotext' },
	                'June 2020 - They decide, \u201CWe want to be married\u201D and a month later\u2026 here we are!'
	            ),
	            _react2.default.createElement('img', { src: _config2.default.img.rings, alt: 'Rings' })
	        )
	    );
	};
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Home = __webpack_require__(68);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(_Home2.default, null);
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-92208786d084b9108b6a.js